import axios from 'axios'
import { API_BASE } from '../constants/inviteCode'
import { domainsMatch, normalizeDomain } from './domain'

export const parseLeadsResponse = (data) => {
  if (Array.isArray(data)) return data
  if (Array.isArray(data?.items)) return data.items
  if (Array.isArray(data?.leads)) return data.leads
  return []
}

export const filterLeadsByDomain = (leads, domain) =>
  leads.filter((lead) => domainsMatch(lead.domain, domain))

export const fetchLeadsForDomain = async (token, domain) => {
  const domainPart = normalizeDomain(domain)
  const domainLabel = String(domain ?? '').trim() || domainPart

  if (!domainPart) return []

  const headers = { Authorization: `Bearer ${token}` }
  const requestLeads = async (params = {}) => {
    const response = await axios.get(`${API_BASE}/leads`, { headers, params })
    return parseLeadsResponse(response.data)
  }

  let items = filterLeadsByDomain(
    await requestLeads({ domain: domainLabel, limit: 100 }),
    domain
  )

  if (items.length === 0 && domainLabel !== domainPart) {
    items = filterLeadsByDomain(
      await requestLeads({ domain: domainPart, limit: 100 }),
      domain
    )
  }

  if (items.length === 0) {
    items = filterLeadsByDomain(await requestLeads({ limit: 500 }), domain)
  }

  return items
}

export const deleteLead = async (token, leadId) => {
  await axios.delete(`${API_BASE}/leads/${leadId}`, {
    headers: { Authorization: `Bearer ${token}` },
  })
}

export const deleteLeadsForDomain = async (token, domain) => {
  const leads = await fetchLeadsForDomain(token, domain)
  if (leads.length === 0) {
    return { deleted: 0, cancelled: false }
  }

  const proceed = window.confirm(
    `This city has ${leads.length} related lead${leads.length === 1 ? '' : 's'} that must be deleted before the city can be removed. Delete ${leads.length === 1 ? 'this lead' : 'all leads'} and remove the city?`
  )
  if (!proceed) {
    return { deleted: 0, cancelled: true }
  }

  for (const lead of leads) {
    await deleteLead(token, lead.id)
  }

  return { deleted: leads.length, cancelled: false }
}
